/* PAWS & PEARLS — HOUSE SOUND v1c | STABLE CONTROLS AFTER SHOPIFY HYDRATION
 * One optional House-wide preference. No surprise announcements.
 * Plays the welcome bell ONLY following the visitor's explicit Sound On gesture.
 * Does not modify The Muse or the Lilla animation engines.
 * The mobile icon is inserted inside the existing Shopify header-actions element.
 */
(function () {
  'use strict';
  if (window.ppHouseSound) return;
  var STORAGE_KEY = 'pp-house-sound-v1';
  var CONFIG_SELECTOR = '[data-pp-house-sound-config]';
  var enabled = false, hasChoice = false, disposed = false;
  var bell = null, status = null, prompt = null, desktopButton = null, mobileButton = null;
  var bellUrl = '';
  var audioContext = null, buffers = Object.create(null), activeSounds = [];
  function unlockAudioContext() {
    if (!enabled) return;
    try {
      var Constructor = window.AudioContext || window.webkitAudioContext;
      if (!Constructor) return;
      if (!audioContext) audioContext = new Constructor();
      if (audioContext.state === 'suspended') audioContext.resume().catch(function () {});
      // Starting a silent, tiny buffer during the actual visitor interaction
      // gives Web Audio its own activation, independent of the welcome bell.
      var b = audioContext.createBuffer(1, 1, 22050);
      var source = audioContext.createBufferSource();
      source.buffer = b;
      source.connect(audioContext.destination);
      source.start(0);
    } catch (error) { /* audio remains optional */ }
  }
  function stopAllEffects() {
    activeSounds.slice().forEach(function (entry) { try { entry.stop(); } catch (error) {} });
    activeSounds = [];
  }
  function loadAudioBuffer(url) {
    if (!audioContext || !url) return Promise.resolve(null);
    if (!buffers[url]) {
      buffers[url] = fetch(url).then(function (r) {
        if (!r.ok) throw new Error('Audio download failed');
        return r.arrayBuffer();
      }).then(function (bytes) { return audioContext.decodeAudioData(bytes); })
        .catch(function () { return null; });
    }
    return buffers[url];
  }
  function playEffect(url, volume) {
    if (!enabled || !url || disposed) return null;
    var requestedVolume = Number(volume);
    var level = Number.isFinite(requestedVolume) ? Math.max(0, Math.min(1, requestedVolume)) : 0.32;
    var entry = {
      stopped: false, source: null, audio: null,
      stop: function () {
        if (entry.stopped) return;
        entry.stopped = true;
        if (entry.source) { try { entry.source.stop(); } catch (error) {} }
        if (entry.audio) { try { entry.audio.pause(); entry.audio.currentTime = 0; } catch (error) {} }
        var n = activeSounds.indexOf(entry);
        if (n !== -1) activeSounds.splice(n, 1);
      }
    };
    activeSounds.push(entry);
    function fallbackAudio() {
      if (entry.stopped || !enabled || disposed) { entry.stop(); return; }
      try {
        var audio = new Audio(url);
        audio.volume = level;
        audio.preload = 'auto';
        entry.audio = audio;
        audio.addEventListener('ended', function () { entry.stop(); }, { once: true });
        var outcome = audio.play();
        if (outcome && typeof outcome.catch === 'function') {
          outcome.catch(function () { entry.stop(); });
        }
      } catch (error) { entry.stop(); }
    }
    // An unlocked Web Audio context is best for rare future effects.
    // HTMLAudioElement remains the fallback where Web Audio is unavailable.
    if (!audioContext || audioContext.state !== 'running') {
      fallbackAudio();
      return entry;
    }
    loadAudioBuffer(url).then(function (buffer) {
      if (entry.stopped || !enabled || disposed) { entry.stop(); return; }
      if (!buffer || !audioContext || audioContext.state !== 'running') {
        fallbackAudio();
        return;
      }
      try {
        var source = audioContext.createBufferSource();
        var gain = audioContext.createGain();
        gain.gain.value = level;
        source.buffer = buffer;
        source.connect(gain);
        gain.connect(audioContext.destination);
        entry.source = source;
        source.onended = function () { entry.stop(); };
        source.start(0);
      } catch (error) { fallbackAudio(); }
    }).catch(function () { fallbackAudio(); });
    return entry;
  }

  function getStoredChoice() {
    try {
      var value = localStorage.getItem(STORAGE_KEY);
      if (value === 'on' || value === 'off') return value;
    } catch (error) { /* storage optional */ }
    return null;
  }
  function saveChoice() {
    try { localStorage.setItem(STORAGE_KEY, enabled ? 'on' : 'off'); }
    catch (error) { /* storage optional */ }
  }
  var remembered = getStoredChoice();
  hasChoice = remembered !== null;
  enabled = remembered === 'on';

  function buttonLabel() { return enabled ? 'Turn House sound off' : 'Turn House sound on'; }
  function refresh() {
    [desktopButton, mobileButton].forEach(function (button) {
      if (!button) return;
      button.setAttribute('aria-label', buttonLabel());
      button.setAttribute('title', buttonLabel());
      button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
      button.classList.toggle('pp-house-sound__on', enabled);
      var readable = button.querySelector('.pp-house-sound__sr-only');
      var spoken = enabled ? 'Sound on' : 'Sound off';
      if (readable && readable.textContent !== spoken) readable.textContent = spoken;
    });
  }
  function notify() {
    window.dispatchEvent(new CustomEvent('pp:house-sound-change', {detail: {enabled: enabled}}));
  }
  function stopBell() {
    if (!bell) return;
    try { bell.pause(); bell.currentTime = 0; } catch (error) { /* silent */ }
  }
  function soundFailed() {
    if (status) status.textContent = 'Sound could not play. Your selection is saved; you can try again with the sound control.';
  }
  function playBellFromGesture() {
    if (!enabled || !bellUrl || disposed) return;
    if (!bell) {
      bell = new Audio(bellUrl);
      bell.preload = 'auto';
      bell.loop = false;
      bell.volume = 0.30;
    }
    try {
      stopBell();
      var result = bell.play();
      if (result && typeof result.catch === 'function') result.catch(soundFailed);
    } catch (error) { soundFailed(); }
  }
  function setEnabled(next, playWelcome) {
    enabled = !!next;
    hasChoice = true;
    saveChoice();
    if (!enabled) { stopBell(); stopAllEffects(); }
    refresh();
    notify();
    if (enabled && playWelcome) {
      unlockAudioContext();
      var lillaConfig = document.querySelector('[data-pp-house-rare-config]');
      if (lillaConfig) {
        try { var lc = JSON.parse(lillaConfig.textContent); if (lc.soundAsset) loadAudioBuffer(lc.soundAsset); }
        catch (error) { /* no effect on visitor */ }
      }
    }
    if (prompt) { prompt.remove(); prompt = null; }
    // Called synchronously by the real click/tap event when requested.
    if (enabled && playWelcome) playBellFromGesture();
  }
  function makeIconButton(extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'pp-house-sound__control ' + extraClass;
    if (extraClass.indexOf('__mobile') !== -1) b.classList.add('header-actions__action');
    b.innerHTML = '<svg class="pp-house-sound__speaker-on" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M18.5 5.5a9 9 0 0 1 0 13"/></svg>' +
      '<svg class="pp-house-sound__speaker-off" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H3v6h3l5 4V5Z"/><path d="m16 9 6 6"/><path d="m22 9-6 6"/></svg>' +
      '<span class="pp-house-sound__sr-only"></span>';
    b.addEventListener('click', function () { setEnabled(!enabled, !enabled); });
    return b;
  }

  function createPrompt() {
    if (hasChoice || prompt) return;
    prompt = document.createElement('aside');
    prompt.className = 'pp-house-sound__invitation';
    prompt.setAttribute('aria-label', 'House sound preference');
    var title = document.createElement('p');
    title.className = 'pp-house-sound__title';
    title.textContent = 'Welcome to the House';
    var body = document.createElement('p');
    body.className = 'pp-house-sound__description';
    body.textContent = 'Would you like to enter with sound?';
    var actions = document.createElement('div');
    actions.className = 'pp-house-sound__actions';
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.textContent = 'Sound on';
    yes.className = 'pp-house-sound__yes';
    yes.addEventListener('click', function () { setEnabled(true, true); });
    var no = document.createElement('button');
    no.type = 'button';
    no.textContent = 'Continue quietly';
    no.className = 'pp-house-sound__no';
    no.addEventListener('click', function () { setEnabled(false, false); });
    actions.appendChild(yes);
    actions.appendChild(no);
    status = document.createElement('span');
    status.className = 'pp-house-sound__status';
    status.setAttribute('role', 'status');
    prompt.appendChild(title);
    prompt.appendChild(body);
    prompt.appendChild(actions);
    prompt.appendChild(status);
    document.body.appendChild(prompt);
  }
  function attachMobileIfPresent() {
    // Native Shopify header action group; no markup edits to header.liquid.
    var host = document.querySelector('#header-component header-actions');
    if (!host) return;
    if (!mobileButton) mobileButton = makeIconButton('pp-house-sound__mobile');
    if (mobileButton.parentNode !== host) host.appendChild(mobileButton);
    refresh();
  }

  function boot() {
    var configNode = document.querySelector(CONFIG_SELECTOR);
    if (configNode) {
      try {
        var cfg = JSON.parse(configNode.textContent);
        if (cfg && typeof cfg.welcomeUrl === 'string') bellUrl = cfg.welcomeUrl;
      } catch (error) { console.warn('P&P House sound: invalid configuration', error); }
    }
    desktopButton = makeIconButton('pp-house-sound__desktop');
    document.body.appendChild(desktopButton);
    refresh();
    attachMobileIfPresent();
    createPrompt();
    // A remembered sound preference may need a new browser gesture on each
    // document navigation; ordinary interactions can safely re-enable Web Audio.
    document.addEventListener('pointerdown', function () {
      if (enabled && (!audioContext || audioContext.state !== 'running')) unlockAudioContext();
    }, true);
    if (enabled) {
      var lillaConfig = document.querySelector('[data-pp-house-rare-config]');
      if (lillaConfig) {
        try { var lc = JSON.parse(lillaConfig.textContent); if (lc.soundAsset) loadAudioBuffer(lc.soundAsset); }
        catch (error) { /* optional cache */ }
      }
    }

    document.addEventListener('shopify:section:load', attachMobileIfPresent);
    // Header hydration/Shopify editor may replace the action-group DOM.
    var headerGroup = document.getElementById('header-group');
    if (headerGroup && window.MutationObserver) {
      var headerObserver = new MutationObserver(attachMobileIfPresent);
      headerObserver.observe(headerGroup, { childList: true, subtree: true });
    }
    window.addEventListener('pageshow', attachMobileIfPresent);

    // v1c: Shopify can replace storefront DOM after first paint (header hydration,
    // preview updates or same-document page transitions). A button created once
    // can briefly appear and then be detached. Restore only when it is MISSING.
    // Do not mutate on every observed event: that would recreate the Safari
    // observer feedback loop corrected in v1b.
    var recoveryTimer = 0;
    function controlsNeedRecovery() {
      var host = document.querySelector('#header-component header-actions');
      return (desktopButton && !desktopButton.isConnected) ||
        (prompt && !hasChoice && !prompt.isConnected) ||
        (host && (!mobileButton || mobileButton.parentNode !== host));
    }
    function restoreDetachedControls() {
      recoveryTimer = 0;
      if (disposed || !document.body) return;
      if (desktopButton && !desktopButton.isConnected) document.body.appendChild(desktopButton);
      if (prompt && !hasChoice && !prompt.isConnected) document.body.appendChild(prompt);
      var host = document.querySelector('#header-component header-actions');
      if (host && (!mobileButton || mobileButton.parentNode !== host)) attachMobileIfPresent();
    }
    function scheduleRecovery() {
      if (recoveryTimer || !controlsNeedRecovery()) return;
      recoveryTimer = window.setTimeout(restoreDetachedControls, 180);
    }
    if (window.MutationObserver) {
      var recoveryObserver = new MutationObserver(scheduleRecovery);
      recoveryObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
    // Also recover if the page is restored from back-forward cache.
    window.addEventListener('pageshow', scheduleRecovery);
  }
  window.ppHouseSound = {
    isEnabled: function () { return enabled; },
    setEnabled: function (next) { setEnabled(!!next, !!next); },
    playWelcomeBell: playBellFromGesture,
    playEffect: playEffect
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once: true});
  else boot();
})();
